"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = exports.DEFAULT_TARGET_NAME = void 0;
var ioc_1 = require("../ioc");
var inversify_1 = require("inversify");
exports.DEFAULT_TARGET_NAME = Symbol.for('default');
/**
 * Our base store object that adds some simple wrappers around
 * inversify to make getting a store a little more expressive
 *
 * @example ```ts
 * MyStore.get()
 * ```
 */
var Store = /** @class */ (function () {
    function Store() {
    }
    /**
     * Gets an instance of the store
     *
     * Returns a singleton - it will always be the same instance of the store.
     *
     * @param this
     * @returns
     */
    Object.defineProperty(Store, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var container = ioc_1.getCoreContainer();
            // Note that we use a named binding of 'default' so that .get
            // and .getNamed remain compatible.
            if (!container.isBoundNamed(this, exports.DEFAULT_TARGET_NAME)) {
                container.bind(this).toSelf().inSingletonScope().whenTargetNamed(exports.DEFAULT_TARGET_NAME);
            }
            return container.getNamed(this, exports.DEFAULT_TARGET_NAME);
        }
    });
    /**
     * @deprecated If you need to use a store in a more constrained scope, use
     * local state (see the `useEphemeralStore` hook)
     *
     * Gets an instance of the store unique to a passed name
     *
     * Useful when multiple instances of the same store is needed.
     *
     * @param this
     * @param name
     * @returns
     */
    Object.defineProperty(Store, "getNamed", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            var container = ioc_1.getCoreContainer();
            if (!container.isBoundNamed(this, name)) {
                container.bind(this).toSelf().inSingletonScope().whenTargetNamed(name);
            }
            return container.getNamed(this, name);
        }
    });
    Object.defineProperty(Store, "getAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return ioc_1.getCoreContainer();
        }
    });
    Object.defineProperty(Store, "reset", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            ioc_1.getCoreContainer().unbind(this);
            ioc_1.getCoreContainer().bind(this).toSelf().inSingletonScope().whenTargetNamed(exports.DEFAULT_TARGET_NAME);
        }
    });
    Object.defineProperty(Store, "destroy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            try {
                ioc_1.getCoreContainer().unbind(this);
            }
            catch (_a) {
                // No implementation necessary. An error is thrown if the store is
                // already unbound
            }
        }
    });
    Store = __decorate([
        inversify_1.injectable()
    ], Store);
    return Store;
}());
exports.Store = Store;
//# sourceMappingURL=Store.js.map